<template>
  <div>
    <div v-if="show.list" class="rule-list">
        <div class="row">
        <div class="col-sm-12 mb-4">
          <b-button class="float-right" variant="warning" @click="openNewSurvey" :disabled="loading.firts"><feather-icon icon="PlusIcon"/> Nueva Encuesta</b-button>
        </div>
        <div class="col-sm-12">
          <table-render v-show="!loading.firts" id="surveys" :show-checkboxes="false" :actions="actions" :schema="schema" :rows="rows" :loading="loading.surveys">
            <template #activated="scope">
                <b-form-checkbox
                    switch
                    class="checkbox-switch switch-notification ml-1"
                    v-model="scope.rowdata.is_active"
                    @change="() => confirmChangeStatus(scope.rowdata.is_active, scope.rowdata.id)">
                    <span class="personalize-status">{{ !!scope.rowdata.is_active ? 'Activo' : 'Inactivo' }}</span>
                </b-form-checkbox>
            </template>
            <template #publication="scope">
              <span>
                Desde: <br> {{ scope.rowdata.start_date }}
              </span>
              <br>
              <span>
                Hasta: <br> {{ scope.rowdata.end_date }}
              </span>
            </template>
          </table-render>
          <div class="table-render-skeleton" v-show="loading.firts">
            <b-skeleton-table   
              :rows="10"    
              :columns="schema.length || 10"
              :table-props="{ }"/>
          </div>
          <pagination :pagination="pagination" :showSize="true"/>
        </div>
    </div>
    </div>
    <div v-if="show.survey">
      <survey ref="surveyInfo" @refreshTable="refreshTable" @returnSurveys="setView" :data.sync="dialogData" :listCategories="listCategories"/>
    </div>
    <div v-if="show.resultsGraph">
      <results-graph ref="resultsGraph" @returnSurveys="setView" :data.sync="dialogData"/>
    </div>
    <modal-preview ref="modalPreview" :data.sync="infoSurvey"/>
  </div>
</template>
<script>
import ModalPreview from './modals/ModalPreview.vue'
import Survey from './components/Survey.vue'
import ResultsGraph from './components/ResultsGraph.vue'
import BaseServices from '@/store/services/index'
import { mapGetters } from 'vuex'
export default {
  components: {Survey, ModalPreview, ResultsGraph},
  data () {
    return {
      baseService: new BaseServices(this),
      actions: [],
      dialogOpen: false,
      dialogData: {},
      infoSurvey: {},
      notifications: [],
      schema: [],
      rows: [],
      keyTableRender: 0,
      loading: {
        firts: true,
        surveys: false
      },
      pagination: { page: 1, limit: 10, total: 0, loading: false },
      currentNotifications: [],
      show: {
        list: true,
        survey: false,
        resultsGraph: false
      },
      listCategories: []
    }
  },
  watch: {
    generalLoading: {
      handler() {
        this.loading.surveys = !!this.generalLoading.getSurveys
      },
      deep: true
    },
    'pagination.page' () {
      this.getSurveys()
    },
    'pagination.limit' () {
      if (this.pagination.page === 1) this.getSurveys()
    },
    mySession () {
      if (this.mySession.id) this.setInitialData()
    },
    surveys(value) {
      this.rows = value.rows.map(row => {
        const formattedCategory = this.listCategories.find(category => category.id === row.category_id)
        return {
          ...row,
          category: formattedCategory?.text
        }
      })
      this.pagination.total = value.pagination.meta.data_count
      this.pagination.page = value.pagination.meta.page
      this['pagination.limit'] = value.pagination.meta.page_count
      this.loading.firts = false
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      generalLoading: 'getLoading',
      surveys: 'getSurveys'
    })
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    async setInitialData () {
      this.setSchema()
      await this.getCategories()
      this.getSurveys()
    },
    getSurveys () {
      const params = {}
      const queryParams = {
        'limit': this.pagination.limit,
        'page': this.pagination.page
      }
      this.$store.dispatch('fetchService', { name: 'getSurveys', queryParams, params})
    },
    getCategories () {
      return this.baseService.callService('getCategories')
        .then(resp => {
          this.listCategories = resp.data.map(el => ({...el, text: el.name}))
        })
        .catch(err => {
          return err
        })
    },
    setSchema () {
      this.schema = [
        {label: 'Título', sortable: true, key: 'name'},
        {label: 'Categoría', sortable: true, key: 'category'},
        {label: 'Creado', sortable: true, key: 'created_at'},
        {label: 'Publicación', sortable: true, key: 'publication', useSlot: true },
        {label: 'Respuesta', sortable: true, key: 'responses'},
        {label: 'Estado', sortable: true, key: 'activated', useSlot: true },
        {label: 'Acciones', key: 'actions'}
      ]
      this.actions = [
        {action: this.openResult, icon: 'BarChart2Icon', color: 'primary', text: 'Resultados'},
        {action: this.openPreview, icon: 'EyeIcon', color: 'primary', text: 'Previsualización'},
        {action: this.openEdit, icon: 'Edit2Icon', color: 'primary', text: 'Editar'},
        {action: this.confirmDelete, icon: 'TrashIcon', color:'danger', text: 'Eliminar'}
      ]
    },
    openPreview (_id) {
      this.infoSurvey = this.rows.filter(({id}) => id === _id)[0]
      this.$bvModal.show('modalPreview')
    },
    openNewSurvey () {
      this.dialogData = {}
      this.setView({list: false, survey: true, resultsGraph: false})
    },
    openResult (_id) {
      this.dialogData = this.rows.filter(({id}) => id === _id)[0]
      this.setView({list: false, survey: false, resultsGraph: true})
    },
    openEdit (_id) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.dialogData = this.rows.filter(({id}) => id === _id)[0]
      this.setView({list: false, survey: true, resultsGraph: false})
    },
    confirmDelete (id) {
      this.$yesno(this.$t('msg-pregunta-eliminar-elemento'), _ => this.deleteSurvey(id))
    },
    deleteSurvey (id) {
      this.$store.dispatch('fetchService', { name: 'deleteSurvey', params: { id }, onSuccess: () =>  {
        this.$newSuccess('Excelente', 'Se elimino la encuesta')
        this.getSurveys()
      }})
    },
    confirmChangeStatus (status, id) {
      this.$confirm(`¿Está seguro que desea ${status ? 'activar' : 'desactivar'} la encuesta?`, () => this.changeStatus(status, id), null, 'Sí', 'No', true, () => this.cancelChangeStatus(id))
    },
    changeStatus (status, id) {
      const params = {
        survey_id: id
      }
      const queryParams = {
        active: status
      }
      this.baseService.callService('changeStatusSurvey', queryParams, params)
        .then(resp => {
          this.$newSuccess('Excelente', `Se ${status ? 'activo' : 'desactivó'} la encuesta`)
          this.getSurveys()
        })
        .catch(err => {
          this.$newError('Ocurrio un error.', err.message, 'medium')
          this.cancelChangeStatus(id)
        })
    },
    cancelChangeStatus (id) {
      const row = this.rows.filter(row => row.id === id)[0]
      if (row) {
        row.is_active = row.originalStatus
      }
    },
    setView ({list, survey, resultsGraph}) {
      this.show.list = list
      this.show.survey = survey
      this.show.resultsGraph = resultsGraph
    },
    refreshTable () {
      this.getSurveys()
    }
  }
}
</script>